/* tslint:disable */
/* eslint-disable */
export enum CommissionType {
  Fa_Commission = 'FA_COMMISSION',
  Supervisor_Commission = 'SUPERVISOR_COMMISSION',
  Marketing = 'MARKETING'
}
